<template>
 
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="活动名称"><el-input size="small" v-model="searchForm.title" clearable placeholder="请输入活动名称"></el-input></el-form-item>
        <el-form-item label="活动类型">
          <el-select size="small" v-model="searchForm.activity_type" placeholder="请选择" >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="活动报名" :value="0"></el-option>
            <el-option label="到店预约" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select size="small" v-model="searchForm.check_status" placeholder="请选择" >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="未通过" :value="2"></el-option>
            <el-option label="已通过" :value="1"></el-option>
          </el-select>
        </el-form-item>
       
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getSearch()">查询</el-button>
         
        </el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addActivity" v-auth="'/plus/activity/activity/add'">添加活动</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border ref="dragTable" v-loading="loading" :row-key="getRowKey"  @selection-change="tableCurrentChange">
        <el-table-column prop="activity_id" label="活动ID" width="60"></el-table-column>
        <el-table-column prop="address" label="封面" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.img_url" :src="scope.row.img_url" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="user" label="用户" >
            <template  slot-scope="scope">
               <div v-if="scope.row.user">
                  <p>昵称：{{scope.row.user.nickName}}</p>
                  <p>电话：{{scope.row.user.mobile}}</p>
                  <p class="gray9">(用户ID：{{scope.row.user.user_id}})</p>
               </div>
            </template>
          </el-table-column>
        <el-table-column prop="title" label="活动标题">
          <template slot-scope="scope">
            <div :title="scope.row.title">
              <el-tag v-if="scope.row.activity_type == 0" size="mini" type="">活动报名</el-tag>
              <el-tag v-if="scope.row.activity_type == 1" size="mini" type="success">到店预约</el-tag>
              {{scope.row.title}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="联系方式"></el-table-column>
        <el-table-column prop="title" label="活动时间">
          <template slot-scope="scope">
            <p>开始时间：{{scope.row.start_time_text}}</p>
            <p>结束时间：{{scope.row.end_time_text}}</p>
          </template>
        </el-table-column>
      
        <el-table-column prop="sort" label="活动排序" width="100"></el-table-column>
        <el-table-column prop="check_status" label="审核状态" width="100">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.check_status == 1" class="green">已通过</span>
              <span v-if="scope.row.check_status == 2" class="red">未通过</span>
              <span v-if="scope.row.check_status == 0" class="gray">待审核</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="green">显示</span>
            <span v-if="scope.row.status == 0" class="gray">隐藏</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column fixed="right" prop="name" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="logClick(scope.row)" type="text" v-auth="'/plus/activity/activity/log'" size="small">报名记录</el-button>
            <el-button @click="editActivity(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteActivity(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    
  </div>
</template>

<script>
import ActivityApi from '@/api/activity.js';
export default {
  components: {
  },
  data() {
    return {
      /*搜索参数*/
      searchForm: {
        title: '',
        check_status: '-1',
        activity_type: '-1',
      },
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*弹窗*/
      show_popup: {
        batch: false,
      },
      /*批量选中ids*/
      batchIds: [],
      /*是否打开添加弹窗*/
      open_store: false,
      store_data: {},
      is_store: 1,
      isactivity:false,
    };
  },
  created() {
    const params = this.$route.query;
    if(params && params.status){
      this.searchForm.status = 0
    }
    /*获取活动列表*/
    this.getTableList();
  },
  methods: {
    
    // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey (row) {
      return row.activity_id;
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.batchIds = [];
      val.forEach(e => {
        this.batchIds.push(e.activity_id);
      });
    },
    getSearch(){
      let self = this;
      self.page=1
      this.getTableList()
    },
    /*获取活动列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      ActivityApi.activitylist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.is_store = data.data.is_store;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    logClick(row){
      let activity_id = row.activity_id;
      this.$router.push({
        path: '/plus/activity/activity/log',
        query: {
          activity_id: activity_id,
        }
      })
    },

    /*添加活动*/
    addActivity() {
      this.$router.push({
        path: '/plus/activity/activity/add'
      });
    },

    /*编辑活动*/
    editActivity(row) {
      let activity_id = row.activity_id;
      this.$router.push({
        path: '/plus/activity/activity/edit',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*删除活动*/
    deleteActivity(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ActivityApi.deleteActivity(
            {
              activity_id: row.activity_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    /*删除活动分类*/
    deleteCategory(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          ActivityApi.deleteCategory(
            {
              category_id: row.category_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleClick(tab, event) {},

    /*打开分类添加*/
    addCategory() {
      this.open_add = true;
    },

    /*打开分类编辑*/
    editCategory(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*打开弹窗*/
    openPopup(name, item){
      this.show_popup[name] = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.show_popup[f] = e.openDialog;
      if (e.type == 'success') {
        this.getTableList();
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/list.vue